import { IAction } from '../../../__core/Interfaces/IAction';
import CURSE_INSTANCE_ACTIONS from '../Actions/ActionTypes';
import { criteriaGroupsInitState } from '../Components/Gradebook/Reducers/InitState';
import { CriteriaGroupResponse } from '../Components/Gradebook/Types/CriteriaGroupResponse';

export const criteriaGroupsReducer = (
  state: CriteriaGroupResponse = criteriaGroupsInitState,
  action: IAction<CriteriaGroupResponse>
): CriteriaGroupResponse => {
  switch (action.type) {
    case CURSE_INSTANCE_ACTIONS.FETCH_COURSE_CRITERIA_GROUP:
      return { ...action.payload };

    default:
      return state;
  }
};
